import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    View,
    Text,
    TouchableOpacity
} from 'react-native';
import {
    c_white,
    c_third_grey,
    c_primary_red,
    c_grey,
    c_second_white,
    c_second_black
} from '../variables/colors';
import { globalStyle, perfectSize } from '../variables/styles';
import Entypo from '@expo/vector-icons/Entypo';
import Collapsible from 'react-native-collapsible';
import { useNavigation } from '@react-navigation/core';
import { setAlarmRead } from '../store/actions/alarm';
import moment from 'moment';

export default function AlarmItem({ data, unreadList }) {

    const [expanable, setExpand] = useState(true);
    const isRead = _.includes(unreadList, data._id);

    const navigation = useNavigation();
    const dispatch = useDispatch();

    const renderNavButton = () => {
        let title = '';
        let navigationLink = '';
        switch (data.message.data.type) {
            case 'customer_center':
                title = '문의내역 바로가기';
                navigationLink = 'Inquiry';
                break;
            case 'notice':
                title = '공지사항 바로가기';
                navigationLink = 'Notice';
                break;
            case 'invitation':
                title = '초대권 바로가기';
                navigationLink = 'Coupon';
                break;
            case 'order':
                title = '예매확인/취소 바로가기';
                navigationLink = 'ConfirmTicket';
                break;
        }

        return (
            <TouchableOpacity
                onPress={() => navigation.navigate(navigationLink)}
                style={styles.button}>
                <Text style={[globalStyle.smText, { color: c_white }]}>
                    {title}
                </Text>
            </TouchableOpacity>
        )
    }

    const onClick = () => {
        setExpand(!expanable);
        const index = unreadList.indexOf(data._id);
        unreadList.splice(index, 1);
        isRead && dispatch(setAlarmRead(unreadList, data._id));
    }

    return (
        <View>
            <TouchableOpacity
                style={[globalStyle.flexSpaceBetween, styles.alarmItem]}
                onPress={onClick}>
                <View>
                    <View style={globalStyle.flexRow}>
                        <View style={[styles.alarmIcon, { backgroundColor: isRead ? c_primary_red : 'white' }]} />
                        <Text>
                            {data.message.title}
                        </Text>
                    </View>
                    <Text style={[globalStyle.smGreyText, { marginTop: perfectSize(5) }]}>
                        {moment(data.createdAt).format('YYYY.MM.DD HH:mm')}
                    </Text>
                </View>
                {
                    expanable ?
                        <Entypo name="chevron-thin-down" size={perfectSize(18)} color={c_grey} />
                        : <Entypo name="chevron-thin-up" size={perfectSize(18)} color={c_grey} />
                }
            </TouchableOpacity>
            <Collapsible collapsed={expanable}>
                <View style={{ padding: perfectSize(15), backgroundColor: c_second_white }}>
                    <Text style={[globalStyle.smText, { color: c_second_black }]}>
                        {data.message.body}
                    </Text>
                    <View style={styles.buttonWrapper}>
                        {renderNavButton()}
                    </View>
                    {/* <Text style={globalStyle.greySmText}>
                        {'· 예매하신 티켓은 티켓예매 후 24시간 이내에 본인인증 또는 선물하기를 진행하셔야 합니다.\n· 티켓예매 24시간 이내에 본인인증을 하지 않은 티켓은 자동 취소 됩니다. (선물하기의 경우 선물받은이가 티켓 최초 매 시점으로부터 24시간 이내에 본인인증을 진행)'}
                    </Text> */}
                </View>
            </Collapsible>
        </View>
    )
}

const styles = {
    alarmItem: {
        alignSelf: 'stretch',
        paddingVertical: perfectSize(20),
        paddingHorizontal: perfectSize(15),
        borderBottomWidth: 1,
        borderColor: c_third_grey,
    },
    alarmIcon: {
        width: perfectSize(6),
        height: perfectSize(6),
        backgroundColor: c_primary_red,
        borderRadius: perfectSize(6),
        marginRight: perfectSize(4)
    },
    buttonWrapper: {
        alignItems: 'center',
        marginTop: perfectSize(15),
        marginBottom: perfectSize(15)
    },
    button: {
        paddingVertical: perfectSize(11),
        paddingHorizontal: perfectSize(17),
        borderRadius: perfectSize(4),
        backgroundColor: c_primary_red
    },
}